<template>
  <sidebar-item :link="{name: $t('Корпоративная политика'),  path: `/corpPolicy`,  icon: 'vip_icon icon_policy'}">
  </sidebar-item>
</template>
<script>
    export default {
        name: 'CorpPolityMenu',
    }
</script>
